var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-radio-options-box__wrapper", class: _vm.showBefore },
    [
      _c("div", { staticClass: "c-radio-options-box" }, [
        _c("div", { staticClass: "c-radio-options-box__question" }, [
          _c("h2", { staticClass: "c-radio-options-box__title" }, [
            _vm._v(_vm._s(_vm.question.label))
          ]),
          _vm._v(" "),
          _vm.question.helpText
            ? _c("div", {
                staticClass: "c-rap-rte",
                domProps: { innerHTML: _vm._s(_vm.question.helpText) }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "c-radio-options-box__answers",
            class: _vm.columnSize
          },
          [
            _vm._l(_vm.question.options, function(option, index) {
              return _c(
                "div",
                { key: index, staticClass: "c-radio-options-box__answer" },
                [
                  option.img
                    ? _c("div", { staticClass: "c-radio-options-box__image" }, [
                        _c("img", {
                          attrs: { src: option.img, alt: "option.imgAlt" }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "c-radio-options-box__field-container" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.question.answer,
                            expression: "question.answer"
                          }
                        ],
                        staticClass: "c-radio-options-box__field",
                        attrs: {
                          type: "radio",
                          id: option.optionId,
                          name: _vm.question.id
                        },
                        domProps: {
                          value: option.value,
                          checked: _vm._q(_vm.question.answer, option.value)
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.question,
                                "answer",
                                option.value
                              )
                            },
                            function($event) {
                              return _vm.emitInput(
                                $event,
                                index,
                                _vm.question.id,
                                option.nextId,
                                option.final,
                                option.upload
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "c-radio-options-box__label",
                          style: _vm.showIcon(option.ico),
                          attrs: { for: option.optionId }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(option.label) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            _vm._v(" "),
            _vm.question.answerLabel
              ? _c("h3", { staticClass: "c-radio-options-box__replay" }, [
                  _vm._v(
                    "\n        You answered: " +
                      _vm._s(_vm.question.answerLabel) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.cmsText
              ? _c("div", {
                  staticClass: "c-rap-rte",
                  domProps: { innerHTML: _vm._s(_vm.cmsText) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.liveChat || _vm.externalLink
              ? _c("div", { staticClass: "c-radio-options-box__actions" }, [
                  _vm.liveChat
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "c-button c-button--brand c-button--text-center",
                          attrs: { type: "button" }
                        },
                        [_vm._v("\n          Live Chat\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.externalLink
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "c-button c-button--brand c-button--text-center",
                          attrs: { href: _vm.externalLinkUrl }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.externalLinkText) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aeff126c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aeff126c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/report-a-problem/_vue/RadioOptions.vue
// module id = 648
// module chunks = 0